import styled from "styled-components";

import colors from "@src/common/styles/colors";
import { DEFAULT_MARGIN_XL, DEFAULT_MARGIN_M } from "@src/common/styles/const";
import { defaultLetterSpacing, media } from "@src/common/styles/mixins";

export const BoxWrapper = styled.div<{
  isSmallPadding?: boolean;
}>`
  background-color: ${colors.white};
  border-radius: 12px;
  margin-top: ${DEFAULT_MARGIN_XL}px;
  padding: ${(p) => (p.isSmallPadding ? 8 : 24)}px;
  width: 100%;

  ${media.down("MOBILE")`
    padding: ${DEFAULT_MARGIN_M}px;
    margin-top: ${DEFAULT_MARGIN_M}px;
  `}
`;

export const BoxHeadline = styled.div`
  ${defaultLetterSpacing};
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: ${colors.almostBlack};
`;

export const NoDataText = styled.div`
  margin-top: 12px;
  font-size: 12px;
`;
